<p-dialog
  #dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  (onShow)="onShow()"
  [modal]="true"
  class="style2023 dialog-header supplier-schedule-dialog"
  [class]="currentStep.dialogClass"
  [style]="{ width: '950px' }"
  [blockScroll]="true"
  [resizable]="false"
>
  <p-header>
    <span class="header-job" *ngIf="recommendedRouteId">Route {{ recommendedRouteId }}</span>
    <span class="header-job" *ngIf="!recommendedRouteId">{{ headerText }}</span>
  </p-header>

  <div class="pt-3">
    <div class="flex flex-wrap">
      <div class="flex-grow-1">
        <div *ngIf="showSummary">
          <div *ngIf="canEdit">
            <div style="margin-bottom: 5px; font-size: 16px; font-weight: 600">
              {{ confirmText }}
            </div>
          </div>
        </div>
        <div *ngIf="!showSummary">
          <strong>{{ questionText }}</strong>
        </div>
      </div>
      <div class="flex-shrink-1" *ngIf="editTaskList.length > 0">
        <span *ngFor="let task of editTaskList; let i = index" (click)="activeIndex = i">
          <span class="ball" [class.onOrBefore]="i <= activeIndex">{{ i + 1 }}</span
          ><span
            *ngIf="editTaskList.length > i + 1"
            class="link"
            [class.onOrBefore]="i < activeIndex"
          ></span>
        </span>
        <span class="link" [class.onOrBefore]="showSummary"></span>
        <span class="ball" [class.onOrBefore]="showSummary"><i class="fa fa-check"></i></span>
      </div>
    </div>
  </div>

  <div *ngIf="!showSummary">
    <ng-container *ngTemplateOutlet="editPanel"></ng-container>
  </div>

  <div *ngIf="showSummary">
    <ng-container *ngTemplateOutlet="summaryPanel"></ng-container>
  </div>

  <ng-template #summaryPanel>
    <div class="pt-2 pl-3 pr-4">
      <div
        class="supplier-not-available"
        *ngIf="scheduleUnavailability && !scheduleUnavailability.isAvailable"
      >
        <div class="flex grid-gap-10">
          <div class="flex-shrink-1 warning-icon">
            <i class="fa fa-warning" style="color: var(--red-500)"></i>
          </div>
          <div class="flex-grow-1">
            <div class="warning-title">Incompatible Supplier or Schedule</div>
            <div class="warning-text">
              The selected supplier has set their status to 'Do Not Disturb' or 'Unavailable' during
              the scheduled time of this job. Please consider either rescheduling the job for an
              available day or select a different supplier.
            </div>
          </div>
        </div>
      </div>
      <div class="outer-box">
        <div
          *ngIf="
            showSummary &&
            taskScheduleSource == TaskSupplierScheduleSource.JobDeployment &&
            deploySupplierContext
          "
          class="mb-2"
        >
          <div class="inner-box flex flex-wrap justify-content-between">
            <div class="summary-header summary-left-side">Supplier</div>
            <div class="summary-right-side">
              <deploy-supplier-card
                [deploySupplierContext]="deploySupplierContext"
              ></deploy-supplier-card>
            </div>
          </div>
        </div>
        <div
          *ngIf="showSummary && taskScheduleSource == TaskSupplierScheduleSource.JobDeployment"
          class="mb-2"
        >
          <job-schedule-carry-over
            [jobId]="jobId"
            [organisationId]="supplierId"
            [organisationTypeId]="organisationTypeId"
            [taskSupplierScheduleStores]="taskSupplierScheduleStores"
          ></job-schedule-carry-over>
        </div>
        <div
          *ngIf="showSummary && taskScheduleSource == TaskSupplierScheduleSource.JobDeployment"
          class="mb-2"
        >
          <ng-container *ngTemplateOutlet="editPrice"></ng-container>
        </div>
        <div *ngFor="let task of tasks; let taskIndex = index" class="my-2">
          <h4>Task {{ taskIndex + 1 }} of {{ tasks.length }}</h4>
          <travel-scheduler-summary-task
            [task]="task"
            (editScheduleClicked)="handleEditSchedule(taskIndex)"
            [isVME]="true"
          ></travel-scheduler-summary-task>

          <div *ngIf="getUnavailability(task.id)?.length > 0">
            <div class="supplier-not-available mt-2">
              <div class="flex grid-gap-10">
                <div class="flex-shrink-1 warning-icon">
                  <i class="fa fa-warning" style="color: var(--red-500)"></i>
                </div>
                <div class="flex-grow-1">
                  <div class="warning-title">Supplier is unavailable on</div>
                  <div
                    class="warning-text"
                    *ngFor="let unavailability of getUnavailability(task.id)"
                  >
                    <span style="margin-left: 8px">&bull;&nbsp;{{ unavailability.data }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #editPrice>
    <div class="inner-box flex flex-wrap justify-content-between">
      <div class="summary-header summary-left-side">Price</div>
      <div class="summary-right-side text-right">
        <span class="text-4xl link-style mr-1">£</span>
        <input
          pInputText
          [(ngModel)]="priceInput"
          class="text-4xl link-style"
          style="width: 120px"
          (keydown)="inputHelper.allowNumberInputKey($event)"
          (keyup)="inputHelper.fixDigits($event.target)"
        />

        <div class="ml-auto my-4 w-8" *ngIf="hasPriceChanged">
          <p-dropdown
            name="priceChangeReason"
            placeholder="Select a reason for the change in price"
            [options]="priceChangeReasons"
            [(ngModel)]="priceChangeReason"
            [required]="hasPriceChanged"
            filter="true"
          ></p-dropdown>

          <input
            *ngIf="isOtherReasonSelected"
            id="price-change-reason-other"
            type="text"
            pInputText
            [(ngModel)]="priceChangeReasonOtherText"
            [required]="isOtherReasonSelected"
            placeholder="Price Change Reason Text"
            class="w-full text-right mt-4"
          />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #editPanel>
    <p-tabView [activeIndex]="activeIndex">
      <ng-container *ngFor="let task of tasks; let i = index">
        <p-tabPanel
          [class]="'no-border-tabpanel'"
          [header]="i.toString() + ' Pickup'"
          [selected]="canEdit ? i == 0 : false"
        >
          <schedule-task
            (scheduleSelected)="handleScheduleSelected($event)"
            [taskIndex]="activeIndex"
            [task]="tasks[activeIndex]"
            *ngIf="activeIndex < tasks.length && activeIndex != -1"
            [previousTaskDropoffWindow]="getPreviousTaskDropoffWindow()"
            [taskCount]="tasks.length"
            [isVME]="true"
            [supplierId]="supplierId"
            [supplierRestrictsCarryover]="travelSchedulerDTO?.supplierRestrictsCarryover"
            [carryoverValidationResult]="getCarryoverValidationResult()"
            (carryoverValidationResultChange)="handleCarryoverValidationResult($event)"
          ></schedule-task>
        </p-tabPanel>
      </ng-container>
    </p-tabView>
  </ng-template>

  <p-footer class="flex grid-gap-5">
    <div class="flex-grow-1 text-left">
      <div>
        <div class="earnings-label">Supplier Paid</div>
        <div class="earnings-value">&pound;{{ price | number : '1.2-2' }}</div>
      </div>
    </div>
    <div class="flex-shrink-1">
      <button
        pButton
        label="Cancel"
        (click)="onCancel()"
        class="button-style btn-md ui-tertiary-button"
      ></button>
    </div>
    <div *ngIf="backEnabled" class="flex-shrink-1">
      <button
        pButton
        label="Back"
        (click)="back()"
        class="button-style btn-md ui-tertiary-button"
      ></button>
    </div>
    <div *ngIf="nextEnabled" class="flex-shrink-1">
      <button
        pButton
        [disabled]="activeStep.disabled"
        [title]="continueBtnTooltip"
        [label]="activeStep.nextBtnText || 'Continue'"
        (click)="next()"
        class="button-style btn-md ui-primary-button"
      ></button>
    </div>
    <!--
    <div class="flex-shrink-1" *ngIf="activeIndex == allSteps.length">
      <button
        pButton
        (click)="editScheduleClick()"
        label="Edit Schedule"
        class="ui-button-secondary"
      ></button>
    </div>
    -->
    <div *ngIf="canEdit && showSummary == true">
      <button
        pButton
        [disabled]="finalBtnDisabled"
        [title]="finalBtnTooltip"
        (click)="onFinalStepConfirm()"
        [label]="finalBtnText"
        class="button-style ui-primary-button btn-md"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
